<template>
  <section class="view">
    <ToastVoucher :toast-title="checkin ? checkin.voucher_cta_title : null"
                  :toast-text="checkin ? checkin.voucher_cta_text : null"/>
    <ViewLoader v-if="loading"/>
    <template v-else>
      <ModalVoucher :checkinId="checkin.id" @voucher-redeemed="getCheckinDetail(picaCode)"/>
      <ViewHeader :class="{'pb-0': hasFaces}">
        <template #content>
          <div class="checkin-detail-header">
            <div class="container">
              <div class="row-small-gutters">
                <div class="col-12 col-lg">
                  <div class="event-summary">
                    <div class="d-lg-flex justify-content-between">
                      <div
                          class="d-flex justify-content-between justify-content-lg-start align-items-start w-100 w-lg-auto">
                        <div class="d-flex align-items-center w-100 w-lg-auto">
                          <div class="event-summary__logo" v-if="checkin.event_cover">
                            <img :src="checkin.event_cover" alt="Event logo">
                          </div>
                          <div class="w-100 w-lg-auto">
                            <div class="d-flex justify-content-between align-items-start">
                              <div>
                                <h1 class="event-summary__name">{{ eventName }}</h1>
                                <div class="d-flex align-items-baseline">
                                  <div>
                                    <div class="event-status__icon" v-if="!isTaggingCompleted"></div>
                                  </div>
                                  <h6 class="event-summary__subname">{{ checkin.event_subtitle }}</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="hasFaces">
                    <div class="d-flex justify-content-start flex-wrap mt-4 mb-2">
                      <CheckinFaceList @click="openFaceRecognitionModal()" :checkin-faces="checkin.checkin_faces"
                                       :max-faces-count="checkin.max_faces_count"
                                       :disabled="checkin.checkin_faces.length === checkin.max_faces_count"/>
                    </div>
                  </div>
                  <InfoMediaAvailable :available-to="mediaAvailableTo" :last-stay-deletion-date="lastStayDeletionDate"
                                      v-if="mediaAvailableTo" />
                  <InfoHdAvailable :hd-available-to="hdAvailableTo"
                                   v-else-if="hdAvailableTo"/>
                  <InfoMediaDeleted v-else-if="mediaDeleted"/>


                </div>
              </div>
            </div>
          </div>
        </template>
      </ViewHeader>

      <div class="view-body checkin-detail-body" :class="{'mt-0': hasFaces}">

        <Galleries :hide-user-cta="hideUserCta"
                   ref="galleries"
                   @face-checkin-cta="openFaceRecognitionModal(true)"/>

        <AllPhotos :checkin="checkin" v-if="showAllEventPhotos"/>

        <div class="mt-2">
          <StaticBanner :pica-service-id="picaServiceId" :banner="eventBanner"/>
          <WelcomePopup :pica-service-id="picaServiceId" :active="eventPopup.welcome.active === true"
                        :title="eventPopup.welcome.title" :text="eventPopup.welcome.text"/>
          <FixedPopup :pica-service-id="picaServiceId" :active="eventPopup.fixed.active === true"
                      :title="eventPopup.fixed.title" :text="eventPopup.fixed.text"/>

        </div>

        <ShareWithFriends :data="shareWithFriends" :event-name="eventName" v-if="shareWithFriends.enabled"/>

        <AlaskaCTA
            :url="'gohski.es/3RXKwOC'"
            :facebook="'https://pica.musvc2.net/e/tr?q=6%3dIRCaPY%26w%3dT%266%3dRIaQ%26F%3dCWLRCY%26C%3d95M8J_3tkq_Dd_0rds_Jg_3tkq_CiEN8.9s4p57Fv.67D_3tkq_CiA9lKwI_3tkq_CiA9lKwI.1A8_Ibvh_TQN_0rds_KerHzJvB.wJ_3tkq_CiKsinEpN%267%3d5L4OuS.y8B%2604%3dTKVGV%26BJ%3dCcJTBcJaBVLSFY%26z%3d6m4OTGWL5EWL7n5KWJYQYHXw7q74s2lx2o9M7p9vTpVsaE4KYFUQ7HTvVmbI5I6P3IWN'"
            :telegram="'https://pica.musvc2.net/e/tr?q=6%3dMS6aTZ%26p%3dT%260%3dSBaU%26G%3d6WPS6Y%26G%3d0xMBK_vtor_7d_DsWs_Nh_vtor_6iF.Ei_KmuT_UbKl4D7_vtor_6iGJp_KmuT_VbMvE_DsWs_OfkH4KoB.1K_vtor_6iOtbnIqG_KmuT_URLiQF_JUvl_UH_KmuT_iV_JUvl_aJ_KmuT_bN_JUvl_aG_KmuT_UQTDzWuL_KmuT_UQTDOE_JUvl_T9UVqVh_DsWs_NW6c_DsWs_Se_vtor_6XNbEEwKo4_DsWs_NW6coC3_KmuT_UQTDv4GxL_DsWs_Oc_vtor_6XNbPHAC_vtor4w3e_6XNbeM_DsWs_NW6cKGyK_DsWs_NW6cB0sMAK_vtor_6XNbeM_DsWs_NW6cF0i_KmuT_UQTDkGKoB1K_vtor_6XNbk497!_vtor_6XNb_vtor_6XNb_vtor_Jc_DsWs_Uh_vtor_CT_DsWs_TY%26h%3dFGKz6N.FiM%265K%3d5VQX7%26ME%3dTDUOSDUVS7WNW0%26A%3dMSCTzXjZV3DXRTB91a84M8BTx3ibO6eZz8AaS86XPWfby6gW1YDZV30UNZ9Tw8A5'"
            :whatsapp="'https://pica.musvc2.net/e/tr?q=9%3dJS6dQZ%26p%3dW%267%3dSBdR%26G%3d6ZMS6b%26D%3d0xP9K_vwlr_7g_AsWv_Kh_vwlr_6ltHm.S13xOtHt.98E_vwlr_6lB7r0_AsWv_LhxAGL_vwlr_7j_AsWv_Yb_vwlr_Cl_AsWv_RT_vwlr_Ci_AsWv_KW6fpcWn_AsWv_KW6fEK_vwlr_6aKbSxX_JUyi_T9XS_JUyi_YG_NjuT_XNTDg53wGt_JUyi_T9XSuoU_AsWv_KW6fl0sPB_JUyi_UE_NjuT_XNTDr8Go_NjuT_XNTD7C_JUyi_T9XSQsQA_JUyi_T9XSHlKCGw_NjuT_7t3eXNTD7C_JUyi_T9XSLlA_AsWv_KW6faMwG27w_NjuT_XNTDCtEi!_NjuT_XNTD_NjuT_XNTD_NjuT_lS_JUyi_aJ_NjuT_eJ_JUyi_ZA_NjuT_XNbeC80wG2.7w_NjuT_XYUV4dOSi%26w%3dEyOE56.JxL%26mO%3dJU9bL%26Lw%3dXST7WSTDWLV6aO%260%3dCXK480QZ8bQ788y70bx4AYRSBWR49WtV9WNV7cJ8h8x6jZtTjeMU6aRX50M89fS3'"
            :email="'mailto:?subject=%F0%9F%92%9C%20WASH%20vs%20ORE%20%7C%20Alaska%20Sky%20Shots%3A%20Look%20at%20your%20photos%20at%20the%20Huskies%20game%21&body=Look%20at%20your%20photos%3A%20gohski.es%2F3RXKwOC'"
            v-if="checkin && picaServiceId === 2295"/>

        <AlaskaCTA
            :url="'https://bit.ly/40TBQvc'"
            :facebook="'https://www.facebook.com/sharer/sharer.php?u=https://bit.ly/40TBQvc'"
            :telegram="`https://t.me/share/url?url=https://bit.ly/40TBQvc&text=📸[${eventName}]: Look at your photos! 👇`"
            :whatsapp="`https://api.whatsapp.com/send?text=📸[${eventName}]: Look at your photos! 👇 https://bit.ly/40TBQvc`"
            :email="`mailto:?subject=📸[${eventName}]: Look at your photos!&body=Look at your photos: https://bit.ly/40TBQvc`"
            v-if="checkin && picaServiceId === 2394"/>
      </div>


      <ModalRemoveCheckin :checkin-id="checkin.id" :picacode="checkin.picacode"/>

      <ModalShowPicacode :picacode="picaCode"/>
      <ModalShowQrPicacode :picacode="picaCode"/>
      <ModalAnonymizeCheckin :checkin-id="checkin.id"
                             :checkin-anonymize-status="checkin.anonymize_status"
                             :checkin-event-name="eventName"
                             :checkin-anonymize-mode="checkin.anonymize_mode"
                             ref="modalAnonymizeCheckin"
                             @anonymize-call-back="onAnonymizeCallBack"/>

      <ModalCustomCheckinDetail :param="modalCustom"/>

    </template>
  </section>

</template>


<script>
import ViewLoader from "@/components/ViewLoader"
import ViewHeader from '@/components/ViewHeader'
import CheckinFaceList from "@/components/CheckinFaceList"
import ModalRemoveCheckin from "@/components/ModalRemoveCheckin"
import ModalShowPicacode from "@/components/ModalShowPicacode"
import ModalAnonymizeCheckin from "@/components/ModalAnonymizeCheckin"
import ModalVoucher from "@/components/ModalVoucher"
import ToastVoucher from "@/components/ToastVoucher"
import {mapActions, mapGetters, mapMutations} from "vuex";
import ModalShowQrPicacode from "@/components/ModalShowQrPicacode.vue";
import Gallery from "@/domain/metrics/gallery";
import StaticBanner from "@/components/customEvents/StaticBanner.vue";
import ModalCustomCheckinDetail from "@/components/ModalCustomCheckinDetail.vue";
import AlaskaCTA from "@/components/customEvents/AlaskaCTA.vue";
import ShareWithFriends from "@/domain/checkinDetail/ShareWithFriends.vue";
import WelcomePopup from "@/components/customEvents/WelcomePopup.vue";
import FixedPopup from "@/components/customEvents/FixedPopup.vue";
import InfoHdAvailable from "@/domain/checkin/InfoHdAvailable.vue";
import AllPhotos from "@/domain/galleries/allPhotos/AllPhotos.vue";
import Galleries from "@/domain/galleries/Galleries.vue";
import InfoMediaAvailable from "@/domain/checkin/InfoMediaAvailable.vue";
import InfoMediaDeleted from "@/domain/checkin/InfoMediaDeleted.vue";

export default {
  components: {
    InfoMediaDeleted,
    InfoMediaAvailable,
    Galleries,
    AllPhotos,
    InfoHdAvailable,
    FixedPopup,
    WelcomePopup,
    ShareWithFriends,
    AlaskaCTA,
    ModalCustomCheckinDetail,
    StaticBanner,
    ViewLoader,
    ViewHeader,
    CheckinFaceList,
    ModalRemoveCheckin,
    ModalShowPicacode,
    ModalShowQrPicacode,
    ModalAnonymizeCheckin,
    ModalVoucher,
    ToastVoucher
  },

  data() {
    return {
      anonymizing: false,

      loading: true,
      hideUserCta: false,
      timerStarted: false,
      alaskaBanner: null,
      modalCustom: {
        title: null,
        text: null,
        btnOk: null,
        ctas: [],
        config: {scroll: true, textClass: 'text-secondary', textCenter: false}
      }
    }
  },

  beforeDestroy() {
    this.exitCheckin()
    this.unsetEventPopup()

    if (this.timerStarted) Gallery.exitAlbum()

    this.UNSET_PICASERVICE_ID()

    if (this.checkinEventsHandler) {
      this.unsubscribeOnMessageHandler(this.checkinEventsHandler)
    }
  },

  watch: {
    getAppConfigReady: {
      handler: async function (value) {
        if (value) {
          await this.loadCheckinDetailData()
        }
      },
      immediate: true
    },
  },

  computed: {
    ...mapGetters('event', ['picaServiceId']),
    ...mapGetters(['getCustomModalCheckinDetailShown']),
    ...mapGetters('checkinDetail', [
      'checkin',
      'picaCode',
      'isTaggingCompleted',
      'eventBanner',
      'eventPopup',
      'picaServiceId',
      'eventName',
      'shareWithFriends',
      'useGetPicaForYourEvent',
      'hdAvailableFrom',
      'hdAvailableTo',
      'mediaDeleted',
      'lastStayDeletionDate',
      'mediaAvailableTo',
      'showAllEventPhotos'
    ]),
    ...mapGetters('appConfig', [
      'getAppConfigReady', 'hideCart'
    ]),
    hasFaces() {
      return this.checkin.max_faces_count > 1 && this.checkin.checkin_faces.length > 0
    }
  },

  methods: {
    ...mapMutations('event', ['SET_PICASERVICE_ID', 'UNSET_PICASERVICE_ID']),
    ...mapActions('checkin', [
      'openAddSelfieStep'
    ]),
    ...mapActions('checkinDetail', [
      'fetchCheckin', 'unsetEventPopup'
    ]),
    ...mapActions('bannerGetPica', [
      'setCheckinSettings',
      'exitCheckin'
    ]),
    ...mapActions('cartDigitalItems', [
      'fetchDigitalItemsTotals'
    ]),
    ...mapActions('websocket', [
      'subscribeOnMessageHandler',
      'unsubscribeOnMessageHandler',
      'sendMessage'
    ]),

    async loadCheckinDetailData() {
      if (!this.hideCart) {
        await this.fetchDigitalItemsTotals()
      }

      await this.getCheckinDetail(this.$route.params.picacode)

      this.subscribeToWebSocketCheckinEvents(this.$route.params.picacode)
      this.checkinEventsHandler = (message) => {
        if (message.type === 'checkin.new_medias_found' && message.data.picacode === this.$route.params.picacode) {
          this.getCheckinDetail(this.$route.params.picacode)
          if (this.$refs.galleries) this.$refs.galleries.load()
        }
      }
      this.setCheckinSettings(this.useGetPicaForYourEvent)
      await this.subscribeOnMessageHandler(this.checkinEventsHandler)
    },
    async getCheckinDetail(picacode) {
      await this.wait(this.$route.params.msDelay || 0)
      try {
        await this.fetchCheckin(picacode)
      } catch (error) {
        if (error.response.status === 404) {
          await this.$router.push({name: 'checkins-list'})
          return
        }
      }

      this.SET_PICASERVICE_ID(this.checkin.pica_service_id)

      this.showCustomModalMessages()

      // open face recognition modal
      if (this.$route.params.openFaceReconition) {
        this.openFaceRecognitionModal(true);
      }

      if (this.$route.params.openAnonymize) {
        await this.$nextTick()
        setTimeout(() => {
          this.$bvModal.show('modal-anonymize-checkin')
        }, 600)
      }

      this.loading = false
      await this.$nextTick()
      Gallery.enterInAlbum(this.picaServiceId)
      this.timerStarted = true
    },

    subscribeToWebSocketCheckinEvents(picacode) {
      this.sendMessage({
        type: 'checkin.subscribe',
        data: {picacodes: [picacode]}
      })
    },
    openFaceRecognitionModal(recognitionFallbackMode = false) {
      this.openAddSelfieStep({
        checkin: {id: this.checkin.id, picacode: this.checkin.picacode},
        max_faces_count: this.checkin.max_faces_count,
        checkin_faces: this.checkin.checkin_faces,
        user_cta: this.checkin.user_cta,
        liveness_detection_enabled: this.checkin.liveness_detection_enabled,
        stay_mode: null,
        face_checkin_privacy_statement: null,
        callback: (checkinId, newCheckinFaces, faceCheckinComplete = false) => {
          if (checkinId === this.checkin.id) {
            this.$set(this.checkin, 'checkin_faces', newCheckinFaces)
          }

          if (recognitionFallbackMode && faceCheckinComplete) {
            this.hideUserCta = true
          }

          if (this.anonymizing) {
            this.$refs.modalAnonymizeCheckin.takeAction()
            this.anonymizing = false
          }
        }
      })
    },

    onAnonymizeCallBack({anonymizeStatus, checkinFaceMissing}) {
      if (anonymizeStatus) {
        this.checkin.anonymize_status = anonymizeStatus
      }

      if (checkinFaceMissing) {
        this.anonymizing = true
        this.openFaceRecognitionModal();
      }
    },
    showCustomModalMessages() {
      if (this.getCustomModalCheckinDetailShown(this.picaServiceId)) return

      if (this.picaServiceId === 2178)
        this.modalCustom.text = this.$t('modal_custom_checkin_detail.text_event_2178')
      else if (this.picaServiceId === 2440 || this.picaServiceId === 2468 || this.picaServiceId === 2556)
        this.modalCustom.text = this.$t('modal_custom_checkin_detail.text_event_2440', {privacy_file: 'https://www.inter.it/it/informativa-privacy-serviziopica'}) // inter
      else if (this.picaServiceId === 2363) {
        this.modalCustom.config = {scroll: false, textClass: 'text-primary'}
        this.modalCustom.text = this.$t('modal_custom_checkin_detail.text_event_2363') // mgmotor
      } else if (this.picaServiceId === 2394) {
        this.modalCustom.ctas.push({
          label: "Go to UW vs. Oregon album",
          url: "https://www.getpica.com/preview/?ps=2295&pc=%23ALASKA23-C843680DE-7BJZ4XHP4&src=dl&tag=calendar"
        })
        this.modalCustom.title = this.$t('modal_custom_checkin_detail.title_event_2394')
        this.modalCustom.text = this.$t('modal_custom_checkin_detail.text_event_2394')
        this.modalCustom.config = {scroll: false, textCenter: true}
      } else if (this.picaServiceId === 2491) {
        this.modalCustom.ctas.push({
          label: "Go to The Global Event Tech Summit 2023",
          url: "https://www.getpica.com/preview/?ps=2385&pc=%23CNSUMMIT-DC89958EC-QW77ROEP6&src=dl&tag=calendar"
        }, {
          label: "Go to EN Indy Conference and Awards 2023",
          url: "https://www.getpica.com/preview/?ps=2193&pc=%23ENINDY23-F5BD25056-AASJVGB8E&src=dl&tag=calendar"
        })
        this.modalCustom.title = this.$t('modal_custom_checkin_detail.title_event_2491')
        this.modalCustom.text = this.$t('modal_custom_checkin_detail.text_event_2491')
        this.modalCustom.config = {scroll: false, textCenter: true}
      } else if (this.picaServiceId === 2511) {
        this.modalCustom.btnOk = this.$t('modal_custom_checkin_detail.btn_ok_event_2511')
        this.modalCustom.text = this.$t('modal_custom_checkin_detail.text_event_2511')
        this.modalCustom.config = {scroll: false, textCenter: true}
      } else {
        return
      }

      setTimeout(() => this.$bvModal.show('modal-custom-checkin-detail'), 600)
      this.$store.commit('SET_CUSTOM_MODAL_CHECKIN_DETAIL_SHOWN', {[this.picaServiceId]: true})
    }
  },
}
</script>

